<div class="setting-section">
  <h2>Machine Management</h2>

  <app-machine-mngt-detail
    [customers]="customers"
    [machines]="dataSource.data"
    (machineSaved)="onMachineSaved($event)"
  ></app-machine-mngt-detail>

  <mat-form-field>
    <input
      matInput
      type="text"
      (keyup)="doFilter($any($event.target).value)"
      placeholder="Filter Machines"
    />
  </mat-form-field>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" class="machinesTable" matSort>
      <ng-container matColumnDef="serialNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>SerialNumber</th>
        <td mat-cell *matCellDef="let element">{{ element.serialNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>
      <ng-container matColumnDef="operator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Operator</th>
        <td mat-cell *matCellDef="let element">{{ element.operator }}</td>
      </ng-container>
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let element">{{ element.customerName }}</td>
      </ng-container>
      <ng-container matColumnDef="function">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Function</th>
        <td mat-cell *matCellDef="let element">
          {{ functonLabel[element.function] }}
        </td>
      </ng-container>
      <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Year</th>
        <td mat-cell *matCellDef="let element">{{ element.year }}</td>
      </ng-container>
      <ng-container matColumnDef="machineType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let element">{{ element.machineType }}</td>
      </ng-container>
      <ng-container matColumnDef="hasImage">
        <th mat-header-cell *matHeaderCellDef>Image</th>
        <td mat-cell *matCellDef="let element">
          <a
            *ngIf="element.hasImage"
            mat-mini-fab
            (click)="viewImgDialog(element.id)"
            >View</a
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="actionButtonCol">
          <button mat-raised-button color="primary" (click)="edit(element)">
            Edit
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="deleteConfirmDialog(element)"
          >
            Delete
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">No machines found"</td>
      </tr>
    </table>
  </div>
</div>
